export default "__VITE_ASSET__X27ojroU__"